<template>
  <el-container class="body-container" style="position: relative;min-height: 100vh;flex-direction: column;">
    <el-header style="height: 56px;display: flex;align-items: center;justify-content: end;width: 1020px;max-width: 1020px;margin: 0 auto;padding-right: 0;">
      <el-button type="primary" size="mini" @click="closeWindow">返回</el-button>
    </el-header>
    <el-main class="body-main" style="background-color: #fff;padding: 20px 26px 46px;border-radius: 8px;box-shadow: 0 0 8px 0 rgba(0, 0, 0, .03);">
      <div style="min-height: calc(100vh - 162px);">
        <h1>{{ form.title }}</h1>
        <div class="body-new__author">
          <!-- <div>{{ form.author }}</div> -->
          <div class="body-new__time">发布时间：{{ changeDay(form.publishTime) }}</div>
          <el-button type="primary" :disabled="form.isRead == '0'? false:true" v-if="form.category === 'notice' && form.readFlag === 1" size="mini" @click="readone">已读</el-button>
        </div>
        <!-- <div v-if="form.picUrl" style="text-align: center;">
          <el-image :src="form.picUrl" style="width: 640px;"></el-image>
        </div> -->
        <div v-html="form.content" class="body-new__mainstay">
        </div>
        <div v-if="attachedFiles.length > 0">
          <div>附件</div>
          <file-list-show :attachedFileList="attachedFiles" style="margin-top: 4px;"></file-list-show>
        </div>
        <div class="body-new_operation">
          <div class="new_operation" @click="option('main')">
            <div class="new_operation--icon"><i class="el-icon-s-home"></i></div>
            <div>首页</div>
          </div>
          <div class="new_operation" @click="option('refresh')">
            <div class="new_operation--icon"><i class="el-icon-refresh-left"></i></div>
            <div>刷新</div>
          </div>
          <div class="new_operation" @click="option('share')">
            <div class="new_operation--icon"><i class="el-icon-share"></i></div>
            <div>分享</div>
          </div>
        </div>
      </div>
      <!-- <div class="footCss"></div> -->
    </el-main>
  </el-container>
</template>

<script>
import { copyLink } from '@/assets/common/common.js'
import moment from 'moment';
import fileListShow from '@/components/fileListShow'
export default {
  name: 'news',
  components: {
    fileListShow,
  },
  data() {
    return {
      moment,
      copyLink,
      form:{},
      attachedFiles:[]
    }
  },
  methods: {

    getNewDetail(id) {
      let formData = new FormData()
      formData.append('articleId',id)
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/findWebArticleById', formData)
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.form = res.data.data
            if(this.form.category === 'notice'){
              this.referWebNotice(id)
            }
            this.getFile(id)
          }
        })
    },
    
    referWebNotice(id) {
      let data = {
        data:id
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/referWebNotice', data)
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
          }
        })
    },
    getFile(id) {
      let data = {
        bizId:id,
        bizCode: "new_add",
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/base/file/findFile', {data:data})
        .then(res => {
          if (res.data.code === '0000') {
            this.attachedFiles = res.data.data
          }
        })
    },
    closeWindow(){
      window.close()   
    },
    readone(){
      if(this.form.isRead == '1') return ;
      let data = {
        data:this.$route.params.id
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/readWebNotice', data)
        .then(res => {
          if (res.data.code === '0000') {
            this.$message({
                message: '阅读完成',
                type: 'success'
              })
            console.log(res.data.data)
            this.form.isRead = '1'
          }
        })
    },
    changeDay(data) {
      return moment(data).format('YYYY年MM月DD日')  
    },
    option(type) {
      if (type === 'main') {
        this.$router.push({ path:"/main" })
      } else if (type === 'refresh') {
        location.reload();
      } else if (type === 'share') {
        this.copyLink(window.location.href)
      }
    }
  },
  created() {
    console.log(this.$route) 
    this.getNewDetail(this.$route.params.id)
  },
}
</script>

<style lang="less" scoped>
.body-main {
    width: 1020px;
    max-width: 1020px;
    margin: 0 auto;
    // height: calc(100vh - 10%);

    h1 {
      color: #333;
      font-family: PingFang SC;
      font-size: 22px;
      font-weight: 600;
      line-height: 56px;
      margin-bottom: 25px;
      margin-top: 8px;
      overflow-wrap: break-word;
      text-align: center;
    }

    .body-new__author {
      color: #333;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      line-height: 14px;
      margin-bottom: 30px;
      justify-content: space-between;
      margin-right:8px; 
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      

      .body-new__time {
        color:#9195a3;
        font-size: 14px;
        line-height: 12px;
        margin-top: 5px;
        margin-bottom: 15px;
        width: 60%;
        text-align: right;
      }

      .el-button {
        height: 24px;
        padding: 0 12px;
        border-radius: 10px;
      }
    }

    .body-new__mainstay {
      font-size: 14px;
      margin: 8px 0px 0px;
      padding: 0px 80px;
      line-height: 1.7;

      /deep/ .ql-align-center {
        text-align: center !important;
      }

      /deep/ p:has(img){
        text-align: center !important;
      }

      /deep/ img {
        border-radius: 6px;
        display: inline-block;
        height: 100%;
        width: 640px;
        cursor: zoom-in;
        cursor: default;
      }

      // /deep/ span {
      //   display: block;
      //   width: 100%;
      //   text-align: left;
      // }
    }

    .body-new_operation {
      margin-left: -90px;
      position: fixed;
      text-align: center;
      top: 200px;
      z-index: 9;
      font-size: 12px;
      cursor: pointer;

      .new_operation {
        margin-bottom: 24px;

        .new_operation--icon {
          background-color: #f7f7f7;
          border-radius: 50%;
          height: 48px;
          margin: 0 auto;
          position: relative;
          width: 48px;
          margin-bottom: 5px;

          .el-icon-s-home, .el-icon-refresh-left,.el-icon-share {
            font-size: 22px;
            margin-top: 12px;
          }
        }
      }
    }
}
.el-button--primary.is-disabled {
  color: #9195a3;
  border-color: #9195a3;
  background-color: #fff;
}
.footCss {
  position: absolute;
  bottom: 0;
  width: 1210px;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 106px;
  box-sizing: border-box;
  background: url(../../assets/images/red-footer-background.png) no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/main/news.vue